import { FowlBetBarComponent } from 'components/fowl-bet-bar-component';

export class SocialFowlBetBarComponent extends FowlBetBarComponent {
  /**
   * Remove balance text.
   * @protected
   * @override
   */
  protected setupTexts(): void {
    super.setupTexts();
    this.layer.getText('balance_value').visible = false;
    this.layer.getText('balance_label').visible = false;
  }
}
